import { getUrlParamsByObject } from 'Utils/url';
import { httpClientFarm } from './microservice-http-clients';

export const getList = (limit, order, s) => httpClientFarm.get(`/${getUrlParamsByObject({ limit, order, s })}`);
export const getFarmData = (slug, privateToken) => {
  let path = `/${slug}`;
  if (privateToken) path = `${path}?private_token=${privateToken}`;
  return httpClientFarm.get(path);
};
export const getClosedSuccessfullyList = (limit, s) => httpClientFarm.get(`/closed${getUrlParamsByObject({ limit, s })}`);
export async function getStats() {
  const { data } = await httpClientFarm.get('/stats');
  return data;
}
